import React from 'react';
import './SplashScreen.css';

/**
 * Premium splash screen shown while the app initializes auth.
 * Displays the Ruta Mundial brand with a smooth animation.
 */
export default function SplashScreen() {
  return (
    <div className="splash-screen">
      <div className="splash-content">
        {/* Logo */}
        <div className="splash-logo">
          <div className="splash-icon">
            <span className="material-symbols-outlined" style={{ fontSize: 48, fontVariationSettings: "'FILL' 1" }}>
              travel_explore
            </span>
          </div>
          <h1 className="splash-title">Ruta Mundial</h1>
          <p className="splash-subtitle">Agencia de viajes</p>
        </div>

        {/* Loading indicator */}
        <div className="splash-loader">
          <div className="splash-bar">
            <div className="splash-bar-fill" />
          </div>
          <p className="splash-status">Preparando tu espacio de trabajo...</p>
        </div>
      </div>
    </div>
  );
}
